<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {wxLogin} from '@/utils/util'
export default {
  name: 'App',
  created(){
  },
  mounted(){
  },
  methods:{
  },
}
</script>

<style>
html{
  background: #f5f5f5;
  /* background: #ff0; */
}
#app {
  font-family:'PingFang SC'， 'Avenir', Helvetica, Arial, sans-serif;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  font-size: 12px;
}
.container{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
}
.red{
  color:rgba(243,71,64,1) !important;
}
.btnColor{
  color: #fff;
  background:linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1));
}
 /* pop弹窗 */
  .van-popup--center{
      width: 80%;
      border-radius: 5px;
  }
  .van-popup--center{
      overflow-y:visible;
  }
   .van-dialog__header{
        font-size: 20px;
        color: #333;
        letter-spacing:2px;

    }
    .van-dialog /deep/ .van-dialog__message--has-title{
        padding-top: 20px;
        font-size: 15px;
        color: #333;
        letter-spacing:1px;
    }
    .van-dialog /deep/ .van-dialog__confirm,.van-dialog /deep/ .van-dialog__confirm{
        color: #F34740;
    }
    .van-dialog /deep/ .van-button{
    border-top: 1px solid #C3C3C3 !important;
    }
    .van-dialog /deep/ .van-button.van-dialog__cancel{
    border-right: 1px solid #C3C3C3 ;
    }
    .van-cell:not(:last-child)::after{
        border: 0 !important;
    }

    .van-sticky [class*=van-hairline]::after,.van-grid[class*=van-hairline]::after{
      border:0;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue